import React from "react"
import { Info } from "lucide-react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../ui/tooltip"

/**
 * Tooltips component - Migrated to use shadcn/ui Tooltip
 * 
 * @param {string} info - Tooltip text content
 * @param {string} placement - Tooltip placement (right, left, top, bottom)
 */
const Tooltips = (props) => {
  const { info, placement = "right" } = props

  // Don't render if no info text
  if (!info) return null

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className="h-[18px] w-[18px] cursor-help text-muted-foreground hover:text-foreground transition-colors inline-block" />
        </TooltipTrigger>
        <TooltipContent
          side={placement}
          className="max-w-[250px] whitespace-normal text-sm"
        >
          <p>{info}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default Tooltips;